<template>
  <div class="channel_list_op1"
  >
    <span class="ope" @click="edit" style="margin-right: 20px;">编辑</span>
    <Poptip
      v-model="visible"
      trigger="click"
      :placement="placement"
      :transfer="true"
      width="420">
      <span class="ope">复制链接</span>
      <div slot="content">
        <div style="height: 24px; text-align: right;">
          <i class="iconfont iconquxiao" style="cursor: pointer" @click="visible=false"></i>
        </div>
        <clipboard :clipboardText="rowData.link_industry" label="工业注册链接"></clipboard>
        <clipboard :clipboardText="rowData.link_service" label="服务商注册链接"></clipboard>
        <clipboard :clipboardText="adminUrl" label="运营后台链接"></clipboard>
      </div>
    </Poptip>
  </div>
</template>
<script>
import clipboard from '@/components/clipboard'
export default {
  name: 'channelOpe1',
  components: {
    clipboard
  },
  data() {
    return {
      visible: false
    }
  },
  props: {
    rowData: Object,
    field: String,
    index: Number
  },
  computed: {
    placement() {
      const totalHeight = document.querySelector('.normal-right-inner-wrap').getBoundingClientRect().height
      if (totalHeight - 138 - 32 - this.index * 32 < 280) {
        if (totalHeight - 138 - 32 - this.index * 32 < 155) {
          return 'right-end'
        } else {
          return 'right'
        }
      } else {
        return 'right-start'
      }
    },
    adminUrl() {
      return this.rowData.link_manage + ' ' + '用户名:' + this.rowData.agent_name + ' 初始密码:123456'
    }
  },
  methods: {
    edit() {
      this.$emit('on-custom-comp', {
        type: 'edit',
        data: this.rowData
      })
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/styles/color.scss';
.channel_list_op1 {
  display: flex;
  justify-content: space-start;
}
.ope {
  color: $blue;
  cursor: pointer;
}
</style>
